<!-- Logo -->
<div class="logo">
  <img src="assets/images/logos/dashboard-logo-1.svg" width="35" height="35" />
  <p class="title-text">LongTail Dashboard</p>
</div>

<div class="container">
  <div class="lottie-container">
    <!-- <ng-lottie width="650px" [options]="animationOptions"></ng-lottie> -->
  </div>

  <div class="error">
    <h1>{{ 'errors.forbidden.group-not-found' | translate }}</h1>
    <p>
      {{ 'errors.forbidden.info-message' | translate }}
    </p>
    <button (click)="navigateToPrevious();" class="btn btn-primary"> {{ 'errors.forbidden.back-to-home' | translate
      }}</button>
  </div>
</div>